import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmDialogContext = React.createContext(null);

export function ConfirmDialogProvider({ children }) {
  const [dialogState, setDialogState] = React.useState({
    isOpen: false,
    title: '',
    content: '',
    resolve: null,
  });

  const confirm = ({ title = 'Are you sure?', content = '' }) => {
    return new Promise((resolve) => {
      setDialogState({
        isOpen: true,
        title,
        content,
        resolve,
      });
    });
  };

  const handleClose = (value) => {
    if (dialogState.resolve) {
      dialogState.resolve(value); // Returns true or false
    }
    setDialogState((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <ConfirmDialogContext.Provider value={confirm}>
      {children}
      <Dialog
        open={dialogState.isOpen}
        onClose={() => handleClose(false)}
        role="alertdialog"
      >
        <DialogTitle>{dialogState.title}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{whiteSpace:'pre-wrap'}}>{dialogState.content}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => handleClose(true)} autoFocus color='success'> אישור </Button>
            <Button onClick={() => handleClose(false)} color='error'> ביטול </Button>
        </DialogActions>
      </Dialog>
    </ConfirmDialogContext.Provider>
  );
}

export const useConfirm = () => {
  const context = React.useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmDialogProvider');
  }
  return context;
};